import {FrameAssemblyInstallation, FrameAssemblyMeasuringPoint, FrameAssemblyType} from "@/helpers/constants";
import {ValidationRule} from "@/declarations/ValidationRule";
import ModelUpdate from "@/models/ModelUpdate";
import {IFrameAssemblyConfiguration} from "@/models/frame-assembly/FrameAssemblyModels";
import FrameAssemblyRules from "@/models/frame-assembly/FrameAssemblyRules";

export default class FrameAssemblyUpdate extends ModelUpdate<IFrameAssemblyConfiguration> {

	public frameType!: FrameAssemblyType;
	public width!: number;
	public height!: number;
	public quantity!: number;
	public measuringPoint!: FrameAssemblyMeasuringPoint;
	public installation!: FrameAssemblyInstallation;
	public positionNr!: string | null;

	public constructor(model: IFrameAssemblyConfiguration, frameType: FrameAssemblyType) {
		super();
		this.frameType = frameType;
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IFrameAssemblyConfiguration): void {
		this.width = detailModel.width;
		this.height = detailModel.height;
		this.quantity = detailModel.quantity;
		this.measuringPoint = detailModel.measuringPoint;
		this.installation = detailModel.installation;
		this.positionNr = detailModel.positionNr;
	}

	public rules(property: string): ValidationRule[] {
		switch (property){
			case 'width':
				if (this.frameType === FrameAssemblyType.corner) return FrameAssemblyRules.cornerWidthRules;
				return FrameAssemblyRules.widthRules;
			case 'height':
				if (this.frameType === FrameAssemblyType.corner) return FrameAssemblyRules.cornerHeightRules;
				return FrameAssemblyRules.heightRules;
			default:
				return [];
		}
	}
}
